import { BrowserRouter as Router, } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { AppRoutes } from './Routes';

function App() {
  return (
    <div className="App">
      <Router>
        <AppRoutes />
      </Router>
      <ToastContainer />
    </div>
  );
}

export default App;
